import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl overflow-hidden border border-background-200/70">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="flex-1 p-6 md:p-10 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900 mb-3">{appData.title}</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5 md:mb-6">{appData.description}</p>
            <div className="grid grid-cols-2 gap-3">
              {appData.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </div>
                  <span className="whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              立即体验 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="flex-shrink-0 lg:w-[320px] p-6">
            <div className="relative mx-auto w-[200px] h-[200px] md:w-[240px] md:h-[240px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=minimalist%20modern%20smartphone%20mockup%20showing%20video%20streaming%20interface%20with%20warm%20coral%20and%20amber%20themed%20UI%2C%20clean%20design%2C%20soft%20lighting%2C%20isometric%20angle%2C%20premium%20product%20photography&width=480&height=480&seq=app-qr&orientation=squarish"
                alt="91视频 - 移动端观看体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}